<template>
  <v-layout
    column
    style="height: 100%"
  >
    <v-layout
      v-if="!hideTitle"
      align-center
    >
      <div class="panelTitle">
        <span>
          用戶註冊
        </span>
      </div>
      <v-spacer />
      <v-btn
        v-if="showClose"
        icon
        small
        @click="$emit('close')"
      >
        <v-icon>close</v-icon>
      </v-btn>
    </v-layout>
    <v-form
      ref="form"
      class="mt-4"
    >
      <v-text-field
        v-model="user.cellphone"
        :rules="[
          $store.state.validationRules.required,
          $store.state.validationRules.cellphone,
        ]"
        solo
        prepend-inner-icon="person"
        label="手機號碼"
        type="text"
      />
    </v-form>
    <v-form ref="form2">
      <v-layout align-center>
        <v-flex>
          <v-text-field
            v-model="user.captcha"
            :rules="[
              $store.state.validationRules.required,
              $store.state.validationRules.captcha,
            ]"
            prepend-icon="code"
            label="驗證碼"
            type="text"
            class="pt-0 mt-0"
          />
        </v-flex>
        <div class="pb-2">
          <v-btn
            :disabled="captchaTimer > 0"
            :loading="sendLoading"
            color="info"
            class="mr-0 mb-2"
            small
            @click="sendSignupCaptcha"
          >
            <span v-if="captchaTimer > 0">
              {{ captchaTimer }} 重新獲取
            </span>
            <span v-else-if="sentCaptch">
              重發驗證碼
            </span>
            <span v-else>
              取得驗證碼
            </span>
          </v-btn>
        </div>
      </v-layout>

      <v-text-field
        v-if="sentCaptch && !isBindAli"
        v-model="user.password"
        :rules="[
          $store.state.validationRules.required,
          $store.state.validationRules.password,
        ]"
        prepend-icon="lock"
        label="密碼"
        type="password"
      />
    </v-form>

    <v-card
      v-if="showMgbPromoCode"
      class="mb-2"
    >
      <v-card-text>
        <v-text-field
          v-model="promoCode"
          placeholder="推廣碼（非必填）"
          class="mt-0 pt-0"
          hide-details
        />
      </v-card-text>
    </v-card>

    <v-card
      v-else-if="!hideInvite"
      class="px-2 py-2 mb-2"
    >
      <div class="mb-1">
        如果感謝讓你知道巧巧郎的人，可以免費送給他1000金巧幣，可填寫
      </div>
      <v-radio-group
        v-model="inviteType"
        row
        class="mt-0 mb-2"
        hide-details
      >
        <v-radio
          label="推薦人邀請碼"
          value="code"
        />
        <v-radio
          label="通關密語"
          value="pwd"
        />
      </v-radio-group>
      <v-layout
        v-if="inviteType === 'code'"
        align-center
        class="ma-0 px-2"
      >
        <div
          style="font-size: 24px;"
          class="mr-2 grey--text"
        >
          KKR
        </div>
        <v-flex class="pr-4">
          <InputLattice
            v-model="user.refUidKkr"
            :len="6"
            small
          />
        </v-flex>
      </v-layout>
      <v-text-field
        v-else
        v-model="passphraseCode"
        placeholder="通關密語"
        class="mt-0 pt-0"
        hide-details
      />
    </v-card>
    <div>
      <div
        v-if="errorMessage"
        class="red--text my-2"
      >
        {{ errorMessage }}
      </div>
      <div
        v-if="isBindAli"
        class="px-4 mt-3"
      >
        <v-btn
          :loading="submitLoading"
          block
          round
          color="info"
          @click="submit"
        >
          確定
        </v-btn>
        <!-- <v-btn
          block
          round
          outlined
          class="mt-3"
          @click="$emit('close')"
        >
          取消
        </v-btn> -->
      </div>
      <v-btn
        v-else-if="sentCaptch"
        :loading="submitLoading"
        color="orange white--text mt-2"
        block
        @click="submit"
      >
        同意協議並註冊
      </v-btn>
    </div>
    <div
      v-if="!isBindAli"
      class="caption pt-2 px-2"
    >
      已閱讀並同意以下協議
      <!-- <router-link :to="{name: 'PostDetail', query: {poid: '12115'}}">
            21
          </router-link> -->
      <a
        v-if="$store.state.project === 'mgb-pc'"
        class="mx-2"
        @click="$store.dispatch('viewPost','360934')"
      ><u>《買即可》會員服務條款</u></a>
      <a
        v-else
        class="mx-2"
        @click="$store.dispatch('viewPost','terms')"
      ><u>《巧巧郞》會員服務條款</u></a>
      <a
        @click="$store.dispatch('viewPost',$store.state.project === 'mgb-pc'?'361112':'security')"
      ><u>個人資料安全保障策略</u></a>
    </div>
    <v-spacer />
    <div
      v-if="!isBindAli"
      class="mt-3 text-xs-center"
    >
      已有帳號？
      <a
        class="orange--text"
        @click="$emit('toSignin')"
      ><u>前往登入</u></a>
    </div>

    <GetCaptcha ref="GetCaptcha" />
  </v-layout>
</template>

<script>
import GetCaptcha from '@g/components/GetCaptcha'
import { getSignupPromoRefUidKkr } from '@g/utils/signupPromoCode'
import InputLattice from '@/components/InputLattice'

export default {
  components: {
    InputLattice,
    GetCaptcha
  },
  props: {
    hideInvite: Boolean,
    hideTitle: Boolean,
    showClose: Boolean,
    isBindAli: Boolean,
    stayOnCurrentPage: Boolean,
  },
  data () {
    return {
      submitLoading: false,

      captchaTimer: 0,
      sentCaptch: false,
      sendLoading: false,
      needCatptch: false, // 需要验证码

      user: {
        cellphone: '',
        password: '',
        captcha: '',
        refUidKkr: '',
      },
      errorMessage: '',

      inviteType: 'code',
      passphraseCode: '',
      promoCode: '',
    }
  },
  computed: {
    installedCrx () {
      return this.$store.state.installedCrx
    },
    isMagicbuyPc () {
      return this.$store.state.project === 'mgb-pc'
    },
    showMgbPromoCode () {
      return this.isMagicbuyPc && !this.isBindAli
    },
  },
  watch: {
    'user.password' () {
      this.errorMessage = ''
    },
    'user.captcha' () {
      this.errorMessage = ''
    },
    'user.refUidKkr' () {
      this.user.refUidKkr = this.user.refUidKkr.replace(/\s/g, '')
    },
    promoCode () {
      this.promoCode = this.promoCode.replace(/\s/g, '')
      this.errorMessage = ''
    },
  },
  created () {
    if (this.isMagicbuyPc) {
      this.ensureSignupPromoOptions().catch(() => {})
    }
  },
  methods: {
    async ensureSignupPromoOptions () {
      if (!this.isMagicbuyPc) return
      if (this.$store.state.option.optionApp.fe_refuid_passphrase) return
      await this.$store.dispatch('option/app')
    },
    async sendSignupCaptcha () {
      if (!this.$refs.form.validate()) return
      try {
        this.sendLoading = true
        let gRecaptchaResponse
        if (this.needCatptch) {
          gRecaptchaResponse = await this.$refs.GetCaptcha.validate()
        }
        const res = await this.$store.dispatch('user/login/signupSendCaptcha', {
          cellphone: this.user.cellphone,
          gRecaptchaResponse,
          alibabaOpenUserId: this.$route.query.alibabaOpenUserId,
        }).then(res => {
          if (!res.data.error) {
            this.sentCaptch = true
            this.captchaTimer = 60
            const tiemr = setInterval(() => {
              this.captchaTimer--
              if (this.captchaTimer < 1) {
                clearInterval(tiemr)
                // 重置机器人验证
              }
            }, 1000)
          } else if (res.data.name === 'gRecaptchaResponseEmpty') {
            this.needCatptch = true
          }
          return res
        })
        if (res.data.error) {
          this.errorMessage = res.data.message || res.data.error
        }
      } finally {
        this.sendLoading = false
      }
    },
    async submit () {
      try {
        // if (!this.installedCrx && localStorage.loginCount > 0 && this.$store.state.project === 'pc') {
        //   this.$snackbar('你好像沒有用鑰匙，把鎖頭破壞了！', {
        //     color: 'error'
        //   })
        //   return
        // }
        if (!this.$refs.form.validate() || !this.$refs.form2.validate()) return
        const params = {
          site: 'KK',
          ...this.user,
          refUidKkr: this.user.refUidKkr ? 'kkr' + this.user.refUidKkr : '',
        }
        if (this.showMgbPromoCode && this.promoCode.trim()) {
          await this.ensureSignupPromoOptions()
          const refUidKkr = getSignupPromoRefUidKkr(
            this.$store.state.option.optionApp.fe_refuid_passphrase,
            this.promoCode
          )
          if (!refUidKkr) {
            this.errorMessage = '推廣碼錯誤'
            return
          }
          params.refUidKkr = refUidKkr
        } else if (this.inviteType === 'pwd' && this.passphraseCode) {
          const refuids = JSON.parse(this.$store.state.option.optionApp.fe_refuid_passphrase || '[]')
          const refuidItem = refuids.find(refuidItem => refuidItem.code.toLowerCase() === this.passphraseCode.toLowerCase())
          if (!refuidItem) {
            this.errorMessage = '通關密語錯誤'
            return
          }
          params.refUidKkr = refuidItem.kkr
        }
        if (this.$route.query.alibabaOpenUserId) {
          params.alibabaOpenUserId = this.$route.query.alibabaOpenUserId
        }
        this.submitLoading = true
        const res = await this.$store.dispatch('user/login/signup', {
          ...params,
          config: {
            noShowError: true,
          },
        })
        if (!res.data.error) {
          if (res.data.model.status === 404) {
            this.passwordMessage = '該帳戶已註銷'
          } else {
            if (res.data.model.firstErrors?.YouAlreadyBound1688) {
              this.$snackbar('您的巧巧郎帳號已經綁定過其他1688帳號。', { color: 'error' })
            } else if (res.data.model.firstErrors?.OtherUserAlreadyBound1688) {
              this.$snackbar('這個1688帳號已經被別的巧巧郎帳號綁定，無法再次綁定。', { color: 'error' })
            }
            // this.$snackbar('註冊成功', { color: 'success' })
            if (localStorage.loginCount) {
              localStorage.loginCount = Number(localStorage.loginCount) + 1
            } else {
              localStorage.loginCount = '1'
            }
            if (this.$store.state.project === 'mgb-pc') {
              if (this.stayOnCurrentPage) {
                location.reload()
              } else {
                this.$router.replace({ name: 'DgorderCategory' })
              }
            } else {
              const query = {}
              if (this.$route.query.searchKey) {
                query.searchKey = this.$route.query.searchKey
              }
              if (this.$route.name === 'Parcel') {
                setTimeout(() => {
                  location.reload()
                }, 100)
              }
              this.$router.replace({
                name: 'Parcel',
                query,
              })
            }
          }
        } else {
          this.errorMessage = res.data.message || res.data.error
        }
      } finally {
        this.submitLoading = false
      }
    }
  }
}
</script>
<style lang="postcss" scoped>
.panelTitle {
  font-size: 16px;
  font-weight: bold;
  > span {
    border-bottom:2px solid #FF9800;
  }
}
</style>
